import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <section className="min-h-[80vh] flex items-center px-5 sm:px-8 pt-24">
      <div className="max-w-7xl mx-auto">
        <Seo title="Page not found | Androgen Health" description="This page could not be found." />
        <p className="mono-label text-teal">404</p>
        <h1 className="font-display font-semibold text-5xl sm:text-6xl tracking-tight mt-5">
          This page isn't here.
        </h1>
        <p className="text-mute mt-4 max-w-md leading-relaxed">
          The link may be old or mistyped. The clinical pages below are where most people are
          heading.
        </p>
        <div className="flex flex-wrap gap-3 mt-8">
          <Link to="/" className="btn-primary text-sm" data-testid="notfound-home-link">Back to home</Link>
          <Link to="/learn" className="btn-ghost text-sm" data-testid="notfound-learn-link">Knowledge centre</Link>
        </div>
      </div>
    </section>
  );
}
